module.exports = __webpack_public_path__ + "static/media/18.dd6fc2ec.png";